import { getEnv } from '@/composables/useEnv'
import Intercom, {
  onHide,
  onShow,
  show,
  showArticle,
  shutdown
} from '@intercom/messenger-js-sdk'
import { IUserFromToken } from '@lifk/types'
import { formatFullName } from '@lifk/utils'
import { ref } from 'vue'

export function loadIntercom(user?: IUserFromToken) {
  const env = getEnv('VITE_APP_ENV')

  if (
    (env === 'staging' || env === 'production') &&
    user &&
    user.role !== 'guest'
  ) {
    Intercom({
      app_id: getEnv('VITE_APP_INTERCOM_APP_ID'),
      name: formatFullName(user),
      email: user.email,
      user_id: user._id
    })
  } else {
    Intercom({
      app_id: getEnv('VITE_APP_INTERCOM_APP_ID')
    })
  }
}

export function closeIntercom() {
  shutdown()
}

export function showMessenger() {
  show()
}

export function loadArticle(id) {
  showArticle(id)
}

export const useIntercomVisibility = () => {
  const isOpen = ref<boolean>(false)
  onShow(() => {
    isOpen.value = true
  })
  onHide(() => {
    isOpen.value = false
  })

  return { isOpen }
}
